<script setup lang="ts">
type Props = {
  stickyDisabled?: boolean;
};

const { stickyDisabled = false } = defineProps<Props>();
const { baseHeaderHeight, isHeaderHidden } = useStickyHeaderStore();

const top = computed(() => {
  if (stickyDisabled) return undefined;

  if (isHeaderHidden.value) return "0px";

  return `${baseHeaderHeight.value}px`;
});
</script>

<template>
  <div
    :id="STATIC_HEADER_ID"
    data-cy="static-header"
    :class="{
      sticky: !stickyDisabled,
      'z-10': !stickyDisabled,
    }"
    :style="{
      top,
      transition: !stickyDisabled ? 'top 0.3s ease' : undefined,
    }"
  >
    <slot />
  </div>
</template>
